export default __webpack_public_path__ + "static/KeywordResearch_01_04@2x-f6c2ae3b4914f28ab21dc92c19772191.png";